import {
  Password,
  PasswordProps
} from '@cube3/cubicle/src/core/atoms/InputField/Password';
import React from 'react';
import { getErrorMessage } from '../utils/getErrorMessage';
import { FieldWithState } from '../types/GenericFormTypes';
import { Placement } from '@floating-ui/dom';

export type PasswordFieldProps = Pick<
  PasswordProps,
  'onEnter' | 'passwordRef' | 'autoFill'
> & {
  renderTip?: (props) => JSX.Element;
  tooltipPlacement?: Placement;
};
type Props = FieldWithState<string, 'password'>;

export const PasswordField = (props: Props) => {
  const {
    autoComplete,
    //meta
    error,
    touched,
    invalid,
    active,
    // input
    // own props
    passwordRef,
    autoFill,
    renderTip,
    tooltipPlacement,
    ...restProps
  } = props;

  const errorMessage = error && getErrorMessage(error);
  const shouldError = touched && !active && invalid;

  return (
    <Password
      {...restProps}
      autoComplete={autoComplete}
      messageLabel={errorMessage}
      showMessage={shouldError}
      autoFill={!autoFill ? !!autoComplete : true}
      tooltips={
        renderTip ? renderTip({ error, touched, invalid, active }) : undefined
      }
      passwordRef={passwordRef}
      tooltipPlacement={tooltipPlacement}
    />
  );
};
